import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Betkal_Casting() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>       יציקת בטקל</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Betkal_Casting">  יציקת בטקל</Link>{" "}
</div>
    </div>
        <div className="video-line" />
<div className="video-box2">
  <iframe
    width="100%"
    height="400"
    src="https://www.youtube.com/embed/RzYj6PmqymY?start=11"
    title="YouTube video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>
    <div className="red-banner">
      יציקת בטקל (בטון קל מוקצף) ליצירת שיפועים לגגות
    </div>
</div>

  



      {/* CONTENT */}
<div className="page6">
  <div className="container">

    <div className="content-row2">


      <div className="image-box2">
        <img src="/images/11.jpg" alt="roof" />
      </div>
      <div className="text-box">


  <h2 className="info-title">  בט-קל מהו ומה שימושיו?



</h2>


       <p>  
הבט-קל הוא בטון מוקצף שמשקלו קל בעשרות אחוזים מיציקת בטון רגילה. הבט-קל מגיע כבטון רגיל לפי תערובת שלנו במיקסר רגיל בו מבצעים הקצפה של החומר ולאחר מכן  והזרמה של החומר לגג ע"י משאבה מיוחדת.
          </p>
    <p>  
הבט-קל משמש ליצירת שיפועים תקינים בגג לכיוון פתחי הניקוז.

</p>
    <p>  
את הבט-קל מיישמים בדרך כלל בגגות / מרפסות חדשים ומעליו מבצעים את שכבת האיטום שתיושם בגג/ מרפסת.


</p>
    <p>  
לאחר ביצוע הבט-קל יש לבצע ליציקה אשפרה ע"י מים במשך שלושה ימים ולהמתין בין 14 ל-21 ימים לייבוש סופי של היציקה ( תלוי במזג האוויר) ורק לאחר מכן תבוצע מערכת האיטום.


</p>


      </div>

    </div>





    <ContactSection2/>
<div className="links2">


  <Link to="/Installation_of_high_altitude_infrastructures" className="link-right" >   התקנת תשתיות בגובה</Link>
  <Link to="/Sealing_tiled_roofs_using_an_innovative_method" className="link-left" >   איטום גגות מרוצפים בשיטה חדשנית  </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


